// components/Resources.jsx
import React from 'react';

const Resources = () => {
  const resources = [
    {
      title: 'CR1000Xe',
      description: 'Campbell Scientific CR1000Xe measurement and control datalogger used for collecting sensor data from the bridge monitoring system.',
      image: '/CR1000Xe.png',
      link: 'https://www.campbellsci.com/products/cr1000xe',
    },
    {
      title: 'AVW200',
      description: '2-channel vibrating wire analyzer module for measuring vibrating wire strain gauges and related sensors.',
      image: '/avw200.png',
      link: 'https://www.campbellsci.com/products/avw200',
    },
    {
      title: 'Granite VWire 305',
      description: '8-channel dynamic vibrating wire analyzer for high-speed vibrating wire sensor measurements.',
      image: '/granite.jpg',
      link: 'https://www.campbellsci.com/products/vwire305',
    },
    {
      title: 'AM16/32B Multiplexer',
      description: '16- or 32-channel relay multiplexer that expands the number of sensors connected to a single datalogger.',
      image: '/MUX.jpg',
      link: 'https://www.campbellsci.cc/am16-32b',
    },
  ];

  return (
    <div style={{
      padding: '1rem',
      paddingTop: '6rem',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem',
          paddingTop: '2rem'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            color: '#2c3e50',
            marginBottom: '1rem',
            fontWeight: '600'
          }}>
            Resources & Documentation
          </h1>
          <p style={{
            fontSize: '1.2rem',
            color: '#7f8c8d',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Components used in the project and documentation
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem'
        }}>
          {resources.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '1px solid #e9ecef',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                textDecoration: 'none',
                color: 'inherit',
                display: 'block'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{
                height: '200px',
                overflow: 'hidden',
                backgroundColor: '#f8f9fa'
              }}>
                <img
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    if (e.target.nextSibling) {
                      e.target.nextSibling.style.display = 'flex';
                    }
                  }}
                />
                <div style={{
                  display: 'none',
                  width: '100%',
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#e9ecef',
                  color: '#7f8c8d',
                  fontSize: '1.2rem'
                }}>
                  {item.title}
                </div>
              </div>

              <div style={{ padding: '1.5rem' }}>
                <h3 style={{
                  fontSize: '1.3rem',
                  color: '#2c3e50',
                  marginBottom: '0.75rem',
                  fontWeight: '600',
                  lineHeight: '1.3'
                }}>
                  {item.title}
                </h3>

                <p style={{
                  color: '#7f8c8d',
                  lineHeight: '1.5',
                  marginBottom: '1rem'
                }}>
                  {item.description}
                </p>

                <span style={{
                  display: 'inline-block',
                  backgroundColor: '#3498db',
                  color: 'white',
                  border: 'none',
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  fontSize: '0.9rem',
                  fontWeight: '500'
                }}>
                  View Product
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;
